import React from "react";
import { withStyles } from "@material-ui/core/styles";
import MuiExpansionPanel from "@material-ui/core/ExpansionPanel";
import MuiExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import MuiExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";
import { Link } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Spinner from "../shared/Spinner";
import Content from "./Content";
import { makeStyles } from "@material-ui/core/styles";
import { colors } from "../../theme";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: "32px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "-0.08px",
    color: colors.TEXT_PRIMARY,
    paddingBottom: "9px",
  },
  question: {
    fontSize: "20px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.67",
    letterSpacing: "-0.05px",
    color: colors.TEXT_PRIMARY,
  },
  answer: {
    fontSize: "16px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.7",
    letterSpacing: "-0.04px",
    color: colors.TEXT_PRIMARY,
  },
  icon: {
    color: colors.FAQ_EXPAND_ICON,
  },
}));

const ExpansionPanel = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    borderRadius: "3px",
    boxShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.16)",
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    backgroundColor: colors.FAQ_ANSWER_BG,
  },
}))(MuiExpansionPanelDetails);

export default function FrequentlyAskedQuestions() {
  const languageFilePaths = [
    {
      title: "content:yfca",
      questions: "content:yfca_faq",
    },
    {
      title: "content:statements",
      questions: "content:statements_faq",
    },
    {
      title: "content:account",
      questions: "content:account_faq",
    },
    {
      title: "content:comments",
      questions: "content:comments_faq",
    },
    {
      title: "content:info",
      questions: "content:info_faq",
    },
  ];

  return (
    <Content>
      {languageFilePaths.map((path) => (
        <FaqCategory titlePath={path.title} questionsPath={path.questions} />
      ))}
    </Content>
  );
}

function FaqCategory({
  titlePath,
  questionsPath,
}: {
  titlePath: string;
  questionsPath: string;
}) {
  const classes = useStyles();
  const { t, ready } = useTranslation(["translation", "content"]);

  if (!ready) return <Spinner isVisible={true} />;

  return (
    <div style={{ paddingBottom: "20px", width: "100%" }}>
      <div className={classes.title}>{t(titlePath)}</div>
      <div style={{ paddingLeft: "24px" }}>
        {[...Array(t(questionsPath, { returnObjects: true }).length)].map(
          (e, i) => (
            <ExpansionPanel key={i}>
              <ExpansionPanelSummary
                expandIcon={<ExpandMoreIcon className={classes.icon} />}
              >
                <Typography>
                  <Link
                    component={RouterLink}
                    to="#"
                    className={classes.question}
                  >
                    {t(`${questionsPath}.${i}.question`)}
                  </Link>
                </Typography>
              </ExpansionPanelSummary>
              <ExpansionPanelDetails>
                <span className={classes.answer}>
                  {t(`${questionsPath}.${i}.answer`)}
                </span>
              </ExpansionPanelDetails>
            </ExpansionPanel>
          )
        )}
      </div>
    </div>
  );
}
